
const digest = '7609d10786b81a6e2c4f2bab82b5b99f3cc60bd0e18f292cb042f2bcfea6b46b';
const classes = {"cross":"_cross_yjnmb_1"};
const css = `._cross_yjnmb_1 {
  position: absolute;
  top: 6px;
  right: 6px;
  background: #f12848;
  border: none;
  color: #ffffff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}
._cross_yjnmb_1 svg {
  display: block;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  